import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "./cn";

/**
 * The placeholder's fill. `surface` (the default) is the quiet surface tone,
 * which reads on a white card. `line` is the tone @nt/tokens names for
 * skeleton bars: use it on the page paper or on the surface itself, where the
 * surface fill all but vanishes (about 1.05:1 on paper).
 */
const skeletonVariants = cva(
  "rounded-md animate-pulse motion-reduce:animate-none",
  {
    variants: {
      tone: {
        surface: "bg-muted",
        line: "bg-line",
      },
    },
    defaultVariants: { tone: "surface" },
  },
);

/** A placeholder shape; the caller gives it the size and shape it stands in for. */
function Skeleton({
  className,
  tone,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof skeletonVariants>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(skeletonVariants({ tone }), className)}
      {...props}
    />
  );
}

export { Skeleton };
